import { Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';

import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ElementService } from '@app/services/element.service';
import { Element } from '@app/models';

@Component({
  selector: 'app-list-elements',
  templateUrl: './refill-elements.component.html',
  styleUrls: ['./refill-elements.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RefillElementComponent implements OnInit {

  elementList: any = [];
  dataSource: MatTableDataSource<Element>;


  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = ['elementname', 'storename', 'productname', 'location', 'currentQuantity', 'maxQuantity', 'minQuantity', 'replenishmentStatus'];
  displaySelectColumns: string[] = ['elementname', 'storename', 'productname', 'location', 'currentQuantity', 'maxQuantity', 'minQuantity', 'replenishmentStatus'];

  constructor(
    private elementService: ElementService,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry, 
    private domSanitizer: DomSanitizer
  ) { 
      this.matIconRegistry.addSvgIcon(
        'custom-svg-icon', // Icon name to use in your template
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/export-icon.svg')
      );
  }

  ngOnInit() {
    this.refreshData();
  }

  /* Filter */
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private storeNameFilterPredicate(element: Element, filter: string): boolean {
    const storeName = element.storename && element.storename.storename
      ? String(element.storename.storename).toLowerCase()
      : '';
    return storeName.includes(filter);
  }

  /* Refresh data table */
  refreshData() {
    this.elementService.getRefilled().subscribe(elements => {
      this.elementList = elements;
      this.dataSource = new MatTableDataSource<Element>(this.elementList);
      this.dataSource.filterPredicate = this.storeNameFilterPredicate;
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }, 0);
    })
  }
}